import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Chip,
  Divider,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { formatDate } from '../../Pages/homePageUtils';
import { getActivityName } from '../../services/activityService';
import { getTrainingClassLabel } from '../../services/trainingClassService';

export default function MobileRecentSessions({
  recentSessions,
  activityNamesById,
  trainingClassesByName,
}) {
  return (
    <Stack spacing={1.5}>
      {recentSessions.map((session) => {
        const activities = session?.SessionActivity || [];
        const hasActivities = activities.length > 0;

        return (
          <Paper key={session.id} className="mobile-session-card" elevation={1}>
            <Box className="mobile-session-header">
              <Typography variant="subtitle1">{formatDate(session.sessionDate)}</Typography>
              <Typography variant="body2" color="text.secondary">
                {getTrainingClassLabel(trainingClassesByName, session.sessionClass)}
              </Typography>
            </Box>
            <Divider sx={{ my: 1 }} />
            <Box className="mobile-session-metrics">
              <Chip size="small" label={`Duration: ${session.durationMinutes ?? '-'} min`} />
              <Chip size="small" label={`Intensity: ${session.intensity ?? '-'}`} />
            </Box>

            {hasActivities && (
              <Accordion elevation={0} disableGutters className="mobile-activity-accordion">
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="body2">Activities ({activities.length})</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Box className="activity-collapse">
                    {activities.map((activity) => (
                      <Paper key={activity.id} variant="outlined" className="activity-item">
                        <Typography variant="subtitle2">
                          {getActivityName(activityNamesById, activity.activityId)}
                        </Typography>
                        <Box className="activity-meta">
                          <Chip size="small" label={`Duration: ${activity.durationMinutes ?? 0} min`} />
                        </Box>
                        {activity.notes ? (
                          <Typography variant="body2">{activity.notes}</Typography>
                        ) : (
                          <Typography variant="body2" color="text.secondary">
                            No activity notes.
                          </Typography>
                        )}
                      </Paper>
                    ))}
                  </Box>
                </AccordionDetails>
              </Accordion>
            )}
          </Paper>
        );
      })}
    </Stack>
  );
}
